import { useEffect } from "react";

const REVEAL_THRESHOLD = 0.12;

/**
 * Reveal-on-scroll hook.
 * @param {Array} deps  Optional deps: pass a value that changes when new `.reveal`
 *                       elements are mounted (e.g. an active filter, items.length)
 *                       so the observer picks them up.
 */
export default function useReveal(deps = []) {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal:not(.is-visible)");
    if (els.length === 0) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: REVEAL_THRESHOLD }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
